<template>
    <div class="rounded shadow-lg modal-content-container">
        <div class="p-4">
            <h4 class="text-center fw-bold">Axxess Central</h4>
            <div class="form-group">
                <select class="form-select ps-1 my-4" v-model="selectedOrganization">
                    <option :value="null">-- Select Organization --</option>
                    <option v-for="organization of organizationsList" :value="organization" :key="organization">
                        {{ organization.name }}
                    </option>
                </select>
            </div>
            <div class="mt-1 d-flex px-3 justify-content-center">
                <button @click="cancel()" type="button" class="btn btn-xs me-2 btn-outline-primary py-2 px-4">
                    Cancel
                </button>
                <button
                    @click="ok()"
                    type="button"
                    :disabled="organizationsList.length == 0"
                    class="btn btn-xs btn-primary py-2 px-4"
                >
                    Enter
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./Organizations.ts"></script>
